import { enableAutoTrack, mixpanel } from '@affine/track';
import { appSettingAtom } from '@toeverything/infra';
import { useAtomValue } from 'jotai/react';
import { useEffect } from 'react';

export function Telemetry() {
  const settings = useAtomValue(appSettingAtom);

  useEffect(() => {
    if (settings.enableTelemetry === false) {
      mixpanel.opt_out_tracking();
      return;
    } else {
      mixpanel.opt_in_tracking();
      return enableAutoTrack(document.body, mixpanel.track);
    }
  }, [settings.enableTelemetry]);

  return null;
}
